// Force rebuild - cache bust
const API_BASE_URL = 'https://api.triggerdocs.dev/api';

class APIError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
    this.name = 'APIError';
  }
}

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'An error occurred' }));
    console.error('[API ERROR] Status:', response.status);
    console.error('[API ERROR] Error data:', error);
    throw new APIError(
      error.detail || 'Request failed',
      response.status,
      error
    );
  }
  const data = await response.json();
  console.log('[API SUCCESS] Response data:', data);
  return data;
};

// Helper to construct absolute URLs - ensure proper concatenation
const getAbsoluteUrl = (path) => {
  // If API_BASE_URL already starts with http:// or https://, it's absolute
  // Just concatenate directly to avoid URL constructor issues
  const base = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
  const endpoint = path.startsWith('/') ? path : `/${path}`;
  return `${base}${endpoint}`;
};

export const authAPI = {
  signup: async (email, password) => {
    const url = getAbsoluteUrl('/auth/signup');
    console.log('[SIGNUP] Full URL:', url);
    console.log('[SIGNUP] API_BASE_URL:', API_BASE_URL);
    console.log('[SIGNUP] Request body:', { email, password: '***' });

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    console.log('[SIGNUP] Response status:', response.status);
    console.log('[SIGNUP] Response headers:', Object.fromEntries(response.headers.entries()));

    return handleResponse(response);
  },

  login: async (email, password) => {
    const response = await fetch(getAbsoluteUrl('/auth/login'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    return handleResponse(response);
  },

  getMe: async (token) => {
    const response = await fetch(getAbsoluteUrl('/auth/me'), {
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleResponse(response);
  },
};

export const projectsAPI = {
  getAll: async (token) => {
    const response = await fetch(getAbsoluteUrl('/projects'), {
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleResponse(response);
  },

  create: async (token, name, filesData) => {
    const response = await fetch(getAbsoluteUrl('/projects'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name, files_data: filesData }),
    });
    return handleResponse(response);
  },

  update: async (token, projectId, name, filesData) => {
    const response = await fetch(getAbsoluteUrl(`/projects/${projectId}`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name, files_data: filesData }),
    });
    return handleResponse(response);
  },

  delete: async (token, projectId) => {
    const response = await fetch(getAbsoluteUrl(`/projects/${projectId}`), {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleResponse(response);
  },
};

